import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-front",
  "use": "svg_i-front-usage",
  "viewBox": "0 0 19 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 20\" id=\"svg_i-front\"><path d=\"M16.964 17.577H6.786v-2.812h7.464V7.03h2.714v10.546ZM14.25 4.92V0H0v14.765h4.75v4.921H19V4.921h-4.75Z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol